//import GigyaController from '@/utils/Controllers/Gigya/GigyaController'
//import {bindGigyaToggleContent, handleModalWorkflows} from '@/utils/Controllers/Gigya/Utils'
//import {goLogin} from '@/utils/Common/Redirects'
//import EVENTS from '@/utils/Constants/Events'
//import CONST from '@/utils/Constants/General'

import {setCustomData} from '.'
import {BRAND_KEY} from '../../brand'

// import api
/* import apiGigyaRegisterInfo from '@/api/post/gigyaRegisterInfo'
import pushGtmSiteSignup from '@/utils/Controllers/GTM/Operations/SiteSignUp'
 */
/* const CONTAINER_ID = 'js-dlg-gigya-register-container'
const START_SCREEN = 'gigya-register-screen' */

export default class GigyaRegisterController {
    static onBeforeSubmit(res) {
        if (res.formData['data.emailConfirm']) {
            return res.formData['data.emailConfirm'] === res.formData.email
        }
        return true
    }

    static onSubmit(res, selector = null, origin) {
        const lang = window.gigya.thisScript.lang.originalLang
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        const countryPrefix = window.gigya.thisScript.globalConf.phonePrefixMapping[countryCode]
        const currentPhone = res.formModel?.data?.phones?.mobile
        if (currentPhone) {
            res.formModel.data.phones.mobile = `${countryPrefix}${currentPhone}`
        }

        GigyaRegisterController.handleRegistration(res, selector)
        setCustomData(res, origin)
    }

    static onAfterSubmit = async (res, ssrGigyaMethods) => {
        const {setAccountInfo} = ssrGigyaMethods
        const lang = window.gigya.thisScript.lang.originalLang
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        // get the consent field related to the country code
        const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]
        if (res.form === 'div.gigya-social-login') {
            setAccountInfo({
                uid: res.response.UID,
                data: {
                    brands: {[`${BRAND_KEY}`]: true},
                    origin: 'ECOMMERCE',
                },
                preferences: {
                    [siteConsent]: {
                        isConsentGranted: false,
                        entitlements: [],
                    },
                },
            })
        }
    }

    static async handleRegistration(event, selector = null) {
        const {sourceContainerID} = event

        // GET USER INFO
        // get the user UID
        //const gigyaUID = event.response.UID
        // get the locale
        const lang = window.gigya.thisScript.lang.originalLang
        console.debug('lang', lang)
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        // get the consent field related to the country code
        const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]

        // get the boolean value of the consent checkbox
        const wrapper = document.getElementById(sourceContainerID)
        const isChecked = selector
            ? selector.checked
            : wrapper.querySelector('.gigya-custom-checkbox .gigya-input-checkbox').checked

        // get user email
        //const {email} = event.profile
        // the identifier
        //const identifier = 'ECOMMERCE'
        // get the sms consent uf the user entered his mobile number

        const smsConsent = !!event.formModel?.data?.phones?.mobile

        const isCG = {
            isConsentGranted: isChecked,
            entitlements: isChecked ? [`${BRAND_KEY}${countryCode}`] : [],
        }

        event.formModel.preferences = {}
        event.formModel.preferences[siteConsent] = isCG

        event.formModel.data = {
            ...event.formModel.data,
            SMS_subscription: {[`${BRAND_KEY}`]: isChecked && smsConsent},
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    static onBeforeScreenLoad(res) {
        let interval
        let intervalC = 0
        const intervalM = 30
        ;(() => {
            interval = setInterval(() => {
                const form = document.getElementById('gigya-register-form')
                if (intervalC > intervalM) {
                    clearInterval(interval)
                } else if (form !== null) {
                    clearInterval(interval)
                    const inputName = form.querySelectorAll('[name = "profile.firstName"]')
                    const inputSurname = form.querySelectorAll('[name = "profile.lastName"]')
                    const inputEmail = form.querySelectorAll('[data-gigya-name="email"]')
                    inputName[0].setAttribute('maxlength', '40')
                    inputSurname[0].setAttribute('maxlength', '40')
                    inputEmail[0].setAttribute('type', 'email')
                }
                intervalC += 1
            }, 1000)
        })()
        //return handleModalWorkflows(res)
    }

    static refreshRegister() {
        const popup = document.querySelector('.dln-popup.dln-popup--open')
        if (popup) {
            //DLG.EVE.emit(EVENTS.MODAL.CLOSE, {popup})
        }
    }

    static onAfterScreenLoad(e, isThankYouPage, email) {
        const registerForm = document.querySelector('#register form')
        if (registerForm) {
            registerForm.classList.add('gigya-register-form')
        }

        const submitButton = document.querySelector('#register button[type="submit"]')
        if (submitButton) {
            submitButton.classList.add('gigya-input-submit')
        }

        const firstNameInput = document.querySelector("input[name='profile.firstName']")
        if (firstNameInput) {
            firstNameInput.classList.add('gigya-input-text')
        }

        const lastNameInput = document.querySelector("input[name='profile.lastName']")
        if (lastNameInput) {
            lastNameInput.classList.add('gigya-input-text')
        }

        const emailInput = document.querySelector("input[name='profile.email']")
        if (emailInput) {
            emailInput.classList.add('gigya-label', 'gigya-input-text')
        }

        const phoneInput = document.querySelector("input[name='profile.phone']")
        if (phoneInput) {
            phoneInput.classList.add('gigya-label', 'gigya-input-text')
        }

        setTimeout(() => {
            if (isThankYouPage) {
                const element = document.querySelector('.guest-thank-you [data-gigya-name="email"]')
                element?.setAttribute('disabled', true)
                element?.setAttribute('data-focus-visible-added', true)
                element?.classList.add('focus-visible')
                if (element) element.value = email
            }
        }, 300)
    }
}
